



















































import { Component, Vue } from 'vue-property-decorator'
import { lazySrc } from '@/assets/imageSources'

@Component
export default class Calendar extends Vue {
  private isLoading: boolean = true
  private lazySrc: string = lazySrc

  get dayItems () {
    return this.$store.state.dayItems.all
  }

  mounted () {
    this.readDayItems()
  }

  async readDayItems () {
    this.isLoading = true

    if (!this.dayItems.length) {
      await this.$store.dispatch('readDayItems')
    }

    this.isLoading = false
  }
}
